import React from "react";
import "../css/XenonAiPage.css";
import xenonLogo from "../assets/xenon-logo.png";
import XENON_FEATURES from "../constants/XenonFeatures";
import { ExternalLink } from "lucide-react";

export default function XenonAiPage() {
  return (
    <div className="xenon-wrapper">
      <div className="xenon-container">
        {/* --- Header Section --- */}
        <header className="xenon-header-compact">
          <img src={xenonLogo} alt="Xenon AI Logo" className="xenon-logo-img" />
          <p className="xenon-brand-subtitle">
            Testing workspace for AI-driven quality engineering
          </p>
        </header>

        {/* --- Description --- */}
        <section className="xenon-intro-section">
          <p>
            Xenon’s specialized AI agents collaborate autonomously to plan,
            write, and execute enterprise-grade testing across your entire
            delivery workflow. By shifting quality left, the platform empowers
            BAs, manual testers, and engineers to generate context-aware
            scenarios and self-healing scripts from live metadata in minutes.
            This purpose-built intelligence reduces flaky test failures by 70%,
            automatically triages execution outcomes, and provides a single
            source of truth for release readiness.
          </p>
        </section>

        {/* --- Main Content Split --- */}
        <main className="xenon-split-layout">
          {/* Left: Video Side */}
          <div className="xenon-video-pane">
            <p className="features-label">Demo Video</p>
            <div className="xenon-iframe-container">
              <iframe
                src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7427362968914460672?compact=1"
                frameBorder="0"
                allowFullScreen=""
                title="Xenon Demo"
              ></iframe>
            </div>
            <div className="readiness-info">
              Platform Readiness:{" "}
              <span className="status-highlight">Salesforce Live</span>
            </div>
          </div>

          {/* Right: Feature Side */}
          <div className="xenon-features-pane">
            <div className="agent-vertical-stack">
              <p className="features-label">Key Features of Xenon AI</p>
              {XENON_FEATURES.map((feature) => (
                <div
                  key={feature.id}
                  className="agent-row-minimal"
                  style={{
                    backgroundColor: `${feature.color}08`,
                    borderColor: `${feature.color}20`,
                  }}
                >
                  <div
                    className="agent-icon-circle"
                    style={{ color: feature.color }}
                  >
                    {feature.icon}
                  </div>
                  <div className="agent-text-block">
                    <h4>{feature.title}</h4>
                    <p className="agent-summary-text">{feature.summary}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </main>

        {/* --- Footer Action Bar --- */}
        <footer className="xenon-action-footer">
          <a
            href="https://xenoncloud.jadeglobal.ai"
            target="_blank"
            rel="noreferrer"
            className="xenon-primary-btn"
          >
            Try the live Xenon AI <ExternalLink size={14} />
          </a>
        </footer>
      </div>
    </div>
  );
}
